import styled from 'styled-components';

import { MinBreakpointV2 } from '@xemplo/style-constants';

export * from './menu-item/menu-item.styles';

export const TabMenuWrapper = styled.ul`
  position: relative;
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
  height: 100%;
  gap: var(--tab-menu-gap, 24px);

  @media ${MinBreakpointV2.medium} {
    gap: var(--tab-menu-gap, 32px);
  }
`;

export const ShowMoreIcon = styled.span`
  cursor: pointer;
  display: flex;
  align-items: center;
  height: 100%;
`;
